import axios from "common/configs/axiosConfigs";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-block",
  borderRadius: 8,
  border: "1px solid #ccc",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  padding: 4,
  overflow: "visible",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
  objectFit: "contain",
};

function ImageUploader({
  name,
  onChange,
  value: val,
  defaultPreview,
  thumbnail,
  defaultThumbnail,
}) {
  console.log(val, "val");

  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;

  const [defaultFiles, setDefaultFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState();
  console.log(files);
  useEffect(() => {
    setDefaultFiles(defaultPreview);
  }, [defaultPreview]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      onChange?.({ target: { name, value: [...(val || []), ...acceptedFiles] } });
      setFiles((prev) => [
        ...prev,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    },
  });
  const handleDeleteImg = async (id, isDefault) => {
    if (isDefault) {
      try {
        const { data } = await axios.post("", {
          action: "deletePropertyImage",
          propertyImageId: id,
          companyId,
        });
        if (data?.success) {
          toast.success(data?.msg);
          setDefaultFiles((prev) => prev?.filter((o) => o?.id !== id));
        } else {
          toast.error(data?.error);
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      onChange?.({ target: { name, value: val?.filter((file) => file !== id) } });
      setFiles((prev) => prev?.filter((file) => file !== id));
    }
  };

  const thumbs = [
    ...[...(defaultFiles || [])]?.map((o) => (
      <div style={thumb} key={o?.id}>
        <div className="theme-img overflow-visible">
          <button
            type="button"
            className="delete-img-btn"
            onClick={() => handleDeleteImg(o?.id, true)}
          >
            <i className="bi bi-x-lg"></i>
          </button>
          <img src={o?.path} />
        </div>
      </div>
    )),
    ...files.map((file) => (
      <div style={thumb} key={file.preview}>
        <div className="theme-img overflow-visible">
          <button type="button" className="delete-img-btn" onClick={() => handleDeleteImg(file)}>
            <i className="bi bi-x-lg"></i>
          </button>
          <div>
            <img src={file.preview} />
          </div>
        </div>
      </div>
    )),
  ];

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);
  console.log("a", thumbnail, file);

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <label className="dropzone  d-flex justify-content-center align-items-center">
            <input
              type="file"
              name="thumbnail"
              accept="image/*"
              className="d-none"
              onChange={(e) => {
                const selectedFile = e.target.files[0];

                onChange?.(e);
                setFile(URL.createObjectURL(selectedFile));
              }}
            />
            <div className="mb-0">
              <h2>
                <i className="bi bi-image"></i>
              </h2>
              Select Thumbnail
            </div>
          </label>
          <div style={thumbsContainer}>
            {" "}
            <div style={thumb}>
              <div className="theme-img overflow-visible">
                <img src={file || defaultThumbnail} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-9">
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} />
            <div className="mb-0">
              <h2>
                <i className="bi bi-cloud-arrow-up"></i>
              </h2>
              Drag & drop files here, or click to select files{" "}
              <span className="text-muted">(Optional)</span>
            </div>
          </div>
          <div style={thumbsContainer}>{thumbs}</div>
        </div>
      </div>
    </>
  );
}

export default ImageUploader;
